import type { Announcement, Language } from '../types';
import { pickI18nText } from './i18n';

/** Prefer locale body; fall back to legacy single contentMd. */
export function pickAnnouncementContent(
  announcement: Pick<Announcement, 'contentMd' | 'contentMdI18n'>,
  lang: Language,
): string {
  const fromI18n = pickI18nText(announcement.contentMdI18n, lang);
  if (fromI18n) return fromI18n;
  return String(announcement.contentMd || '').trim();
}
